export default __webpack_public_path__ + "static/media/Venue.723d4474.svg";